import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api";
import { ModalState } from "../../../types/modals";
import { DataParams } from "../../../types/admin";
import { getListItems } from "../adminList";

type ImportIssue = {
    row: number;
    messages: string[];
};

export type ImportResult = {
    created: number;
    updated: number;
    skipped: number;
    errors?: ImportIssue[];
    warnings?: ImportIssue[];
    success_message?: string;
};

export type UserImportModalState = ModalState & {
    result: ImportResult | null;
};

const initialState: UserImportModalState = {
    isOpen: false,
    loading: false,
    error: null,
    result: null
};

type ImportPayload = {
    formData: FormData;
    params?: DataParams;
};

export const importUsersExcel = createAsyncThunk(
    "userImportModal/importUsersExcel",
    async (payload: ImportPayload, thunkAPI) => {
        try {
            const response = await api.post("/API/admin/users/import/", payload.formData, true);
            if (payload.params) {
                thunkAPI.dispatch(getListItems({ listType: "users", ...payload.params }));
            }
            return response;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const slice = createSlice({
    name: "userImportModal",
    initialState,
    reducers: {
        openModal: (state) => {
            state.isOpen = true;
            state.error = null;
            state.result = null;
        },
        closeModal: () => {
            return initialState;
        },
        clearResult: (state) => {
            state.result = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(importUsersExcel.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(importUsersExcel.fulfilled, (state, action: PayloadAction<ImportResult>) => {
                state.loading = false;
                state.error = null;
                state.result = action.payload;
            })
            .addCase(importUsersExcel.rejected, (state, action) => {
                state.loading = false;
                if (typeof action.payload === "string") {
                    state.error = action.payload as string;
                } else if (typeof action.error?.message === "string") {
                    state.error = action.error.message;
                }
            });
    }
});

export const { openModal, closeModal, clearResult } = slice.actions;
export default slice.reducer;
